<template>
  <final-modal v-model="modalShow" @confirm="create">
    <template v-slot:title>{{
      withData
        ? $t("general.update", { item: $t("general.refereeDecision") })
        : $t("general.add", { item: $t("general.refereeDecision") })
    }}</template>
    <div class="text-center">
      <div class="px-3 pt-0">
        <div class="input-group mb-3">
          <span class="input-group-text">{{ $t("general.rule") }}</span>
          <select class="form-select" v-model="rule">
            <option :value="null" disabled selected>
              {{
                $t("general.selectPlaceholder", { item: $t("general.rule") })
              }}
            </option>
            <option v-for="(rule, index) in rules" :key="index" :value="rule">
              {{ rule }}
            </option>
          </select>
        </div>
        <div class="input-group mb-3">
          <span class="input-group-text">{{ $t("general.player") }}</span>
          <select class="form-select" v-model="player">
            <option :value="null" disabled selected>
              {{
                $t("general.selectPlaceholder", { item: $t("general.player") })
              }}
            </option>
            <option
              v-for="(player, index) in flight?.players"
              :key="index"
              :value="player.player"
            >
              {{ player.player }}
            </option>
          </select>
        </div>
        <div class="input-group mb-3">
          <span class="input-group-text">{{ $t("general.description") }}</span>
          <textarea class="form-control" v-model="description"></textarea>
        </div>
      </div>
    </div>
    <template v-slot:actions>
      <div class="d-flex justify-content-between mb-3 mx-3">
        <div class="me-1">
          <button
            type="button"
            class="btn btn-outline-success"
            @click="withData ? update() : create()"
          >
            {{
              withData
                ? $t("general.update", { item: $t("general.refereeDecision") })
                : $t("general.create", { item: $t("general.refereeDecision") })
            }}
          </button>
        </div>
        <div class="ms-1" v-if="withData">
          <button
            type="button"
            class="btn btn-outline-secondary"
            @click="remove"
          >
            {{ $t("general.delete", { item: $t("general.refereeDecision") }) }}
          </button>
        </div>
      </div>
    </template>
  </final-modal>
</template>

<script>
import FinalModal from "@/components/shared/final_modal.vue";
import { mapGetters } from "vuex";
import { http } from "@/http";
import { useToast } from "vue-toastification";
import { TOAST_CONFIGS } from "@/config/toasts";

export default {
  name: "RefereeDecisionModal",
  components: {
    FinalModal,
  },
  setup() {
    return { toast: useToast() };
  },
  data() {
    return {
      modalShow: false,
      description: null,
      rule: null,
      player: null,
      withData: false,
      id: null,
      holeNumber: null,
      flightId: null,
      timeSheetId: null,
    };
  },
  computed: {
    ...mapGetters({
      timeSheets: "timeSheets/timeSheets",
    }),
    rules() {
      const r = [];
      for (let index = 1; index <= 24; index++) {
        r.push(index.toString());
      }
      return r;
    },
    flight() {
      let flight;
      this.timeSheets?.forEach((timeSheet) => {
        const f = timeSheet?.flights?.find((f) => f.id == this.flightId);
        if (f) {
          flight = f;
        }
      });
      return flight;
    },
  },
  methods: {
    getRequestBody() {
      return {
        timeSheetId: this.timeSheetId,
        flightId: this.flightId,
        holeNumber: this.holeNumber,
        rule: this.rule,
        description: this.description,
        userName: this.$root.userInfo().name,
        userInitials: this.$root.userInfo().initials,
        player: this.player,
      };
    },
    create() {
      http
        .post("/api/v1/time-sheet/referee-decisions", this.getRequestBody())
        .then(() => this.reset())
        .catch((err) => this.handleError(err));
    },
    update() {
      http
        .put(
          `/api/v1/time-sheet/referee-decisions/${this.id}`,
          this.getRequestBody()
        )
        .then(() => this.reset())
        .catch((err) => this.handleError(err));
    },
    handleError(err) {
      console.error(err);
      this.toast.error(
        "Invalid data! Please check your input values.",
        TOAST_CONFIGS.INVALID_REQUEST_ERROR
      );
    },
    async remove() {
      await http.delete(`/api/v1/time-sheet/referee-decisions/${this.id}`);
      this.reset();
    },
    reset() {
      this.modalShow = false;
      this.rule = null;
      this.player = null;
      this.description = null;
      this.withData = false;
      this.id = null;
      this.holeNumber = null;
      this.flightId = null;
      this.timeSheetId = null;
    },
    show(timeSheetId, flightId, holeNumber, data = null) {
      this.reset();
      this.modalShow = true;
      this.holeNumber = holeNumber;
      this.flightId = flightId;
      this.timeSheetId = timeSheetId;
      if (data) {
        this.withData = true;
        this.id = data.id;
        this.rule = data.rule == "" ? null : data.rule;
        this.player = data.player == "" ? null : data.player;
        this.description = data.description;
      }
    },
  },
};
</script>
